import { combineReducers } from 'redux'

import { reducer as cartId } from './cartId'
import { reducer as checkResetPasswordToken } from './checkResetPasswordToken'
import { reducer as createAccount } from './createAccount'
import { reducer as createCustomer } from './createCustomer'
import { reducer as me } from './me'
import { reducer as orders } from './orders'
import { reducer as paymentTokens } from './paymentTokens'
import { reducer as resetPassword } from './resetPassword'
import { reducer as resetPasswordEmail } from './resetPasswordEmail'
import { reducer as subscribe } from './subscribe'
import { reducer as token } from './token'
import { reducer as wishlist } from './wishlist'

export const reducer = combineReducers({
  cartId,
  checkResetPasswordToken,
  createAccount,
  createCustomer,
  me,
  orders,
  paymentTokens,
  resetPasswordEmail,
  resetPassword,
  subscribe,
  token,
  wishlist
})
